import { render } from "./KnowledgePointAdmin.vue?vue&type=template&id=14197ef6&scoped=true"
import script from "./KnowledgePointAdmin.vue?vue&type=script&lang=js"
export * from "./KnowledgePointAdmin.vue?vue&type=script&lang=js"

import "./KnowledgePointAdmin.vue?vue&type=style&index=0&id=14197ef6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-14197ef6"]])

export default __exports__